// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  padding: 0;
  width: 100%;
}

.contact-container {
  max-width: 800px;
  margin: 0 auto;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

@media (max-width: 1024px) {
  .contact-container {
    max-width: 100%;
    margin: 0;
  }
}

.contact-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--color-black);
  margin-bottom: 30px;
  text-align: center;
}

.contact-content {
  line-height: 1.7;
  color: var(--color-black);
}

.contact-intro {
  margin-bottom: 40px;
  text-align: center;
}

.intro-text {
  margin-bottom: 20px;
  font-size: 1.1rem;
  color: var(--color-dark-gray);
}

.intro-text:last-child {
  margin-bottom: 0;
}

.contact-form-section {
  margin-bottom: var(--space-8);
  padding: var(--space-6);
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-subtle);
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-black);
  margin-bottom: 25px;
  text-align: center;
}

.contact-form {
  max-width: 600px;
  margin: 0 auto;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-field {
  margin-bottom: 20px;
}

.textarea-label {
  display: block;
  margin-bottom: 8px;
  color: var(--color-black);
  font-weight: 600;
  font-size: 14px;
}

.message-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px 16px;
  border: 1px solid var(--color-gray);
  border-radius: 8px;
  font-family: 'Urbanist', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  background-color: var(--color-white);
  color: var(--color-black);
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.message-textarea::placeholder {
  color: var(--color-gray);
  font-family: 'Urbanist', sans-serif;
}

.message-textarea:focus {
  outline: none;
  border-color: var(--color-primary-green);
  box-shadow: 0 0 0 3px var(--accent-ring);
}

.success-message {
  margin: 20px 0;
  padding: 16px;
  background-color: var(--color-light-green);
  border-radius: 8px;
  border-left: 4px solid var(--color-primary-green);
}

.success-text {
  color: var(--color-dark-gray);
  margin: 0;
}

.error-message {
  margin: 20px 0;
  padding: 16px;
  background-color: var(--color-pastelle-red);
  border-radius: 8px;
  border-left: 4px solid var(--color-warning-red);
}

.error-text {
  color: var(--color-warning-red);
  margin: 0;
}

.submit-button {
  width: 100%;
  height: 48px;
  font-size: 1.1rem;
  font-weight: 600;
}

.direct-contact-section {
  margin-bottom: var(--space-7);
  text-align: center;
  padding: var(--space-6);
  background-color: var(--color-pastelle-blue);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-subtle);
}

.direct-contact-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--color-black);
  margin-bottom: 20px;
}

.email-container {
  margin-bottom: 20px;
}

.email-link {
  text-decoration: none;
  display: inline-block;
  padding: 12px 24px;
  background-color: var(--color-white);
  border-radius: 8px;
  border: 2px solid var(--color-primary-green);
  transition: all 0.2s ease;
}

.email-link:hover {
  background-color: var(--color-primary-green);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.email-text {
  color: var(--color-primary-green);
  margin: 0;
  transition: color 0.2s ease;
}

.email-link:hover .email-text {
  color: var(--text-on-accent);
}

.direct-contact-text {
  color: var(--color-dark-gray);
  margin: 0;
  font-size: 1rem;
}

.contact-closing {
  text-align: center;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid var(--color-light-gray);
}

.closing-text {
  margin-bottom: 20px;
  font-size: 1.1rem;
  color: var(--color-dark-gray);
}

.closing-signature {
  display: inline-block;
}

.closing-signature .typography {
  margin-bottom: 5px;
  font-style: italic;
  color: var(--color-gray-500);
}

.signature-name {
  font-weight: 600;
  color: var(--color-black) !important;
  font-size: 1.1rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .contact-page {
    padding: 0;
  }
  
  .contact-container {
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
  
  .contact-title {
    font-size: 2rem;
  }
  
  .intro-text {
    font-size: 1rem;
  }
  
  .contact-form-section {
    padding: 20px;
    margin-bottom: 30px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  .direct-contact-section {
    padding: 20px;
    margin-bottom: 30px;
  }
  
  .email-link {
    padding: 10px 20px;
  }
  
  .submit-button {
    height: 44px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .contact-container {
    padding: 16px;
  }
  
  .contact-form-section {
    padding: 16px;
  }
  
  .direct-contact-section {
    padding: 16px;
  }
  
  .message-textarea {
    min-height: 100px;
    padding: 10px 14px;
    font-size: 16px; /* Prevents zoom on iOS */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe,EAAE,yBAAyB;EAC5C;AACF","sourcesContent":[".contact-page {\n  padding: 0;\n  width: 100%;\n}\n\n.contact-container {\n  max-width: 800px;\n  margin: 0 auto;\n  background-color: transparent;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n}\n\n@media (max-width: 1024px) {\n  .contact-container {\n    max-width: 100%;\n    margin: 0;\n  }\n}\n\n.contact-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--color-black);\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.contact-content {\n  line-height: 1.7;\n  color: var(--color-black);\n}\n\n.contact-intro {\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.intro-text {\n  margin-bottom: 20px;\n  font-size: 1.1rem;\n  color: var(--color-dark-gray);\n}\n\n.intro-text:last-child {\n  margin-bottom: 0;\n}\n\n.contact-form-section {\n  margin-bottom: var(--space-8);\n  padding: var(--space-6);\n  background-color: var(--color-surface);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-subtle);\n}\n\n.form-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-black);\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.contact-form {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-field {\n  margin-bottom: 20px;\n}\n\n.textarea-label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--color-black);\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.message-textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 12px 16px;\n  border: 1px solid var(--color-gray);\n  border-radius: 8px;\n  font-family: 'Urbanist', sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  background-color: var(--color-white);\n  color: var(--color-black);\n  resize: vertical;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.message-textarea::placeholder {\n  color: var(--color-gray);\n  font-family: 'Urbanist', sans-serif;\n}\n\n.message-textarea:focus {\n  outline: none;\n  border-color: var(--color-primary-green);\n  box-shadow: 0 0 0 3px var(--accent-ring);\n}\n\n.success-message {\n  margin: 20px 0;\n  padding: 16px;\n  background-color: var(--color-light-green);\n  border-radius: 8px;\n  border-left: 4px solid var(--color-primary-green);\n}\n\n.success-text {\n  color: var(--color-dark-gray);\n  margin: 0;\n}\n\n.error-message {\n  margin: 20px 0;\n  padding: 16px;\n  background-color: var(--color-pastelle-red);\n  border-radius: 8px;\n  border-left: 4px solid var(--color-warning-red);\n}\n\n.error-text {\n  color: var(--color-warning-red);\n  margin: 0;\n}\n\n.submit-button {\n  width: 100%;\n  height: 48px;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.direct-contact-section {\n  margin-bottom: var(--space-7);\n  text-align: center;\n  padding: var(--space-6);\n  background-color: var(--color-pastelle-blue);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-subtle);\n}\n\n.direct-contact-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--color-black);\n  margin-bottom: 20px;\n}\n\n.email-container {\n  margin-bottom: 20px;\n}\n\n.email-link {\n  text-decoration: none;\n  display: inline-block;\n  padding: 12px 24px;\n  background-color: var(--color-white);\n  border-radius: 8px;\n  border: 2px solid var(--color-primary-green);\n  transition: all 0.2s ease;\n}\n\n.email-link:hover {\n  background-color: var(--color-primary-green);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.email-text {\n  color: var(--color-primary-green);\n  margin: 0;\n  transition: color 0.2s ease;\n}\n\n.email-link:hover .email-text {\n  color: var(--text-on-accent);\n}\n\n.direct-contact-text {\n  color: var(--color-dark-gray);\n  margin: 0;\n  font-size: 1rem;\n}\n\n.contact-closing {\n  text-align: center;\n  margin-top: 40px;\n  padding-top: 30px;\n  border-top: 1px solid var(--color-light-gray);\n}\n\n.closing-text {\n  margin-bottom: 20px;\n  font-size: 1.1rem;\n  color: var(--color-dark-gray);\n}\n\n.closing-signature {\n  display: inline-block;\n}\n\n.closing-signature .typography {\n  margin-bottom: 5px;\n  font-style: italic;\n  color: var(--color-gray-500);\n}\n\n.signature-name {\n  font-weight: 600;\n  color: var(--color-black) !important;\n  font-size: 1.1rem;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .contact-page {\n    padding: 0;\n  }\n  \n  .contact-container {\n    max-width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .contact-title {\n    font-size: 2rem;\n  }\n  \n  .intro-text {\n    font-size: 1rem;\n  }\n  \n  .contact-form-section {\n    padding: 20px;\n    margin-bottom: 30px;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n  \n  .direct-contact-section {\n    padding: 20px;\n    margin-bottom: 30px;\n  }\n  \n  .email-link {\n    padding: 10px 20px;\n  }\n  \n  .submit-button {\n    height: 44px;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .contact-container {\n    padding: 16px;\n  }\n  \n  .contact-form-section {\n    padding: 16px;\n  }\n  \n  .direct-contact-section {\n    padding: 16px;\n  }\n  \n  .message-textarea {\n    min-height: 100px;\n    padding: 10px 14px;\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
